module.exports = __webpack_public_path__ + "static/Infographi4-5c4fa267226cd3f70e8dda2535031bbb.png";